import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { HDMS_SCOPE_CLASSES } from '@hdms/shared/common-types';

@Injectable({
  providedIn: 'root'
})
export class OverlayWrapperService {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  private static readonly WRAPPER_ID = 'hdms-overlay-wrapper';

  private wrapper: HTMLDivElement;

  constructor(@Inject(DOCUMENT) private readonly document: Document) {
    this.createWrapper();
  }

  public getWrapper(): HTMLDivElement {
    return this.wrapper;
  }

  public removeWrapper(): void {
    this.wrapper.parentElement?.removeChild(this.wrapper);
  }

  private createWrapper(): void {
    this.wrapper = this.document.querySelector(`#${OverlayWrapperService.WRAPPER_ID}`);

    if (!this.wrapper) {
      this.wrapper = this.document.createElement('div');
      this.wrapper.classList.add(...HDMS_SCOPE_CLASSES);
      this.wrapper.id = OverlayWrapperService.WRAPPER_ID;
      this.document.body.appendChild(this.wrapper);
    }
  }
}
